export const isShipmentAdjustable = (clubSubscriptionShipment) => {
  if (
    clubSubscriptionShipment.status === 'Active' &&
    (clubSubscriptionShipment.processingStatus === 'Pending' ||
      clubSubscriptionShipment.processingStatus === 'Skip')
  ) {
    return true;
  }
  return false;
};

export const listClubShipmentItems = (clubMemberShipment, club) => {
  const items = clubMemberShipment.items.map((item) => {
    const product = club.subscription.items.find(
      (pi) => pi.productVariantId === item.productVariantId
    );
    const newItem = {
      id: item.productVariantId,
      productVariantId: item.productVariantId,
      quantity: item.quantity,
      image: '',
      productTitle: '',
      productVariantTitle: '',
      minQuantity: 0,
      maxQuantity: ''
    };

    if (product) {
      newItem.image = product.image;
      newItem.productTitle = product.productTitle;
      newItem.productVariantTitle = product.productVariantTitle;
      newItem.price = product.price;
      newItem.comparePrice = product.comparePrice;
      newItem.minQuantity = product.minQuantity;
      newItem.maxQuantity = product.maxQuantity;
    }
    return newItem;
  });
  const { virtualCart } = clubMemberShipment;

  if (!virtualCart) {
    return items;
  }

  const productItems = items.map((item) => {
    const product = virtualCart.items.find(
      (pi) => pi.productVariantId === item.productVariantId
    );
    const newItem = item;
    newItem.price = product.price;
    newItem.comparePrice = product.comparePrice;
    newItem.image = product.image;
    newItem.productTitle = product.productTitle;
    newItem.productVariantTitle = product.productVariantTitle;
    return newItem;
  });
  return productItems;
};

export const listItemsForClub = (clubSubscriptionShipment, club) => {
  const items = club.subscription.items.map((item) => {
    const newItem = { ...item };
    const itemInShipment = clubSubscriptionShipment.items.find(
      (cms) => cms.productVariantId === item.productVariantId
    );
    if (itemInShipment) {
      newItem.minQuantity -= itemInShipment.quantity;
    }
    if (itemInShipment && newItem.maxQuantity) {
      newItem.maxQuantity -= itemInShipment.quantity;
    }
    if (newItem.minQuantity < 0) {
      newItem.minQuantity = 0;
    }
    if (newItem.maxQuantity && newItem.maxQuantity < 0) {
      newItem.maxQuantity = 0;
    }
    return newItem;
  });
  return items;
};

export const listItemsInClubExceptProductVariant = (
  clubSubscriptionShipment,
  club,
  productVariantId
) => {
  const items = listItemsForClub(clubSubscriptionShipment, club);
  const newItems = items.filter((i) => i.productVariantId !== productVariantId);
  return newItems;
};

export const itemsInClub = (productVariantId, shipment) => {
  const item = shipment.items.find(
    (i) => i.productVariantId === productVariantId
  );
  return item;
};
